import { InViewOnce } from './InViewOnce';

let pageProjects;

function renderPage(rootDom) {
    const selector = {
        ACTIVE: '_active',
    };
    const $list = $('.js-projects-list', rootDom);
    const $categories = $('.js-projects-list-categories a', rootDom);
    const $more = $('.js-projects-list-more', rootDom);
    const $moreButton = $more.find('button');
    const url = $list.data('url');
    let nextPage = $moreButton.data('next-page');

    if (!$list.length) return;

    // HANDLERS
    $categories.on('click', onClickNav);
    $moreButton.on('click', loadMore);

    // PRIVATE
    function onClickNav(e) {
        $categories.removeClass(selector.ACTIVE);
        $(e.currentTarget).addClass(selector.ACTIVE);
    }

    function loadMore() {
        $moreButton.attr('disabled', true);

        $.ajax({
            url: url,
            method: 'get',
            dataType: 'json',
            data: { page: nextPage },
            success: function ({success, content, page, pageLast}) {
                if (success && content) {
                    $list.append(content);
                    $list.find('[data-in-view-once]').each((i, elDom) => InViewOnce(elDom));
                }

                if (pageLast) {
                    $more.attr('hidden', true);
                } else {
                    nextPage = page;
                    $moreButton
                        .attr('data-next-page', nextPage)
                        .data('next-page', nextPage);
                }
            },
            complete: () => {
                $moreButton.removeAttr('disabled');
            }
        });
    }

    // PUBLIC
    function destroy() {
        $categories.off('click', onClickNav);
        $moreButton.off('click', loadMore);
    }

    return {
        destroy
    };
}

App.W.on('barba:afterEnter', (e, data) => {
    const pageContainerDom = data.next.container;
    const projectsListDom = pageContainerDom.querySelector('.js-projects-list');

    if (projectsListDom) {
        pageProjects = renderPage(pageContainerDom);
    }
});

App.W.on('barba:leave', () => {
    if (pageProjects) {
        pageProjects.destroy();
    }
});



// WEBPACK FOOTER //
// ./_src/js/modules/PageProjects.js